import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { SessionService } from "../common/services/session.service";

@Component({
  selector: "app-main-dashboard",
  templateUrl: "./main-dashboard.component.html",
  styleUrls: ["./main-dashboard.component.scss"],
})
export class MainDashboardComponent implements OnInit {
  userInfo: any;
  permissions:any;

  constructor(
    private ss: SessionService,
    private router: Router) {
    this.permissions = this.ss.getAuthPermission();
     }

  setDashboard() {
    if(this.userInfo.role == "SYSTEM_ADMIN"){
      this.router.navigate(["/admin-dashboard"]);
    }else{
      this.permissions.forEach(element => {
        if (element.name == "SUPER_ADMIN_DASHBOARD"||element.name == "OFFICE_ADMIN_DASHBOARD"||element.name == "DASHBOARD") {
        this.router.navigate(["/admin-dashboard"]);
        } else if (element.name == "KARYAKARTA_DASHBOARD") {
          this.router.navigate(["/karyakarta/dashboard"]);
        } else if (element.name == "VIEWER_DASHBOARD") {
          this.router.navigate(["/viewer-dashboard"]);
        }
      });
    }
  }

  ngOnInit() {
    this.userInfo = this.ss.getUserInfo();
    this.setDashboard();
    this.permissions = this.ss.getAuthPermission();
  }
}
